import { render, staticRenderFns } from "./MotivosParosNiveles.vue?vue&type=template&id=4da6b462&"
import script from "./MotivosParosNiveles.vue?vue&type=script&lang=js&"
export * from "./MotivosParosNiveles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports